import React from 'react';
import AudioPlayer from '../../../ui/AudioPlayer';
import TextNote from '../../../ui/TextNote';
import QuestionAndInputs from './QuestionAndInputs';
import { richHTMLFieldHasValue } from '../../../../helpers/utilities';
import { RichTextWrapper } from '../../../templating/RichTextWrapper';
export default function TwoColumn6633Layout({ shortNote, fullText, sectionHeader, questionClarification, explanationText, inputChoices, questionText, }) {
    return (React.createElement("div", null,
        React.createElement("div", { className: "row two-column_66-33", "data-testid": `two-column_66-33_layout` },
            React.createElement("div", { className: "col-8", "data-testid": "left-column" },
                sectionHeader && (React.createElement("h3", { className: "display-text section-header" }, sectionHeader)),
                richHTMLFieldHasValue(explanationText.value) && (React.createElement("div", { className: "display-text explanation" },
                    React.createElement(RichTextWrapper, { richText: explanationText }))),
                !!shortNote && (React.createElement(TextNote, { shortNote: shortNote, longNote: fullText }))),
            React.createElement("div", { className: "col-4", "data-testid": "right-column" },
                React.createElement(QuestionAndInputs, { questionText: questionText, questionClarification: questionClarification, inputChoices: inputChoices }))),
        React.createElement(AudioPlayer, null)));
}
//# sourceMappingURL=TwoColumn6633Layout.js.map